import styled from 'styled-components';
import { space, color, zIndex, top, right, bottom, left } from 'styled-system';

const Fixed = styled.div`
  ${space};
  ${color};
  ${zIndex};
  ${top};
  ${right};
  ${bottom};
  ${left};
  position: fixed;
`;

export default Fixed;
